import { globalTypes } from '../types';
import { reduceAction } from '../helpers';

import types from './types';

export const initialState = () => ({
    dataFields: {
        username: '',
        rememberMe: false,
    },
    loading: false,
    stopErrorResetPropagation: false,
});

const reducers = (state = initialState(), action) => {
    const { payload } = action;
    const { dataFields } = state;

    switch (action.type) {
        case globalTypes.INITIALIZE:
            return initialState();

        case types.SET_LOADING:
            return reduceAction(state, 'loading', !!payload);

        case types.STORE_SELECTED:
            return { ...state };

        case types.SET_ERROR:
            return { ...state, error: { ...payload } };

        case types.SET_LOGIN_POPOVER_NAME:
            return reduceAction(state, 'loginPopoverName', payload.popover);

        case types.SET_DATA_FIELD:
            return {
                ...state,
                dataFields: { ...dataFields, [payload.name]: payload.value },
            };

        case types.INITIALIZE_DATA_FIELD:
            return {
                ...state,
                dataFields: { ...dataFields, ...(payload || {}) },
            };
        case types.SET_STOP_ERROR_RESET_PROPAGATION:
            return {
                ...state,
                stopErrorResetPropagation: action.payload,
            };
        case types.SET_FOCUSED:
            return {
                ...state,
                focusedField: action.payload,
            };
        case types.SET_UNFOCUSED:
            return {
                ...state,
                focusedField: '',
            };
        case types.SET_FB_APP_ID:
            return { ...state, fbAuthId: payload };
        default:
            return state;
    }
};

export default reducers;
